import CssBaseline from '@mui/material/CssBaseline';
import MuiThemeProvider from '@mui/material/styles/ThemeProvider';
import React from 'react';
import { darkTheme, lightTheme } from './theme';
export function LightThemeProvider({ children }) {
    return React.createElement(MuiThemeProvider, { theme: lightTheme },
        React.createElement(CssBaseline, null),
        children);
}
export function DarkThemeProvider({ children }) {
    return React.createElement(MuiThemeProvider, { theme: darkTheme },
        React.createElement(CssBaseline, null),
        children);
}
//# sourceMappingURL=ThemeProvider.js.map